var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryMan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 152 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-18,.cls-23,.cls-8{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:#e2f3f7;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-19,.cls-20,.cls-21,.cls-22,.cls-24,.cls-4,.cls-5,.cls-6,.cls-7,.cls-9{fill-rule:evenodd;}.cls-5{fill:#ff3008;}.cls-6{fill:#ff4f2d;}.cls-7{fill:#ff5e3e;}.cls-8{stroke:#c7c6b5;stroke-width:0.4px;}.cls-9{fill:#c7c6b5;}.cls-10{fill:#fdf88d;}.cls-11{fill:#9cd9e2;}.cls-12,.cls-25{fill:#fff;}.cls-13{fill:#ff431e;}.cls-14{fill:#d2eef2;}.cls-15{fill:#325847;}.cls-16{fill:#da260d;}.cls-17{fill:#c6a581;}.cls-18{stroke:red;stroke-width:0.25px;}.cls-19{fill:#edb9b6;}.cls-20{fill:#22464c;}.cls-21{fill:#528c8f;}.cls-22{fill:#e7e5d5;}.cls-23{stroke:#edb9b6;stroke-width:0.5px;}.cls-24{fill:#ebeade;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-2.64 -9.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 154,
    height: 154
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-2.64 -9.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.64,
    y: 9.17,
    width: 161,
    height: 139
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.89,145.33c31.81-7.93,42.38-32,45-50.78,2.42-17.06-1.08-27.16-14.91-28.71s-10.36-11-9.5-19.26,2.82-16.69-3.62-26.94c-7.77-12.39-28.75-17.2-44.73,5s-28.62,20-43.53,17.48C29.89,40.82,14,35.62,6,50.85c-16.11,30.59,30.41,77.42,30.41,77.42S61.42,157.16,108.89,145.33Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.82,35c-.13.28-6.71,30-6.1,30.31a39,39,0,0,0,8,2.29c4.08.82,8.39,1.28,8.6,1,.41-.43,7-30.6,7-30.6Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.67,59.71c.27.2,11.89,2.56,12.19,2.2s3.06-16,3.06-16S42.71,44.29,42.7,44.54,39.39,59.51,39.67,59.71Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M43.15,42.23c-.08.49-1.91,4.21-.35,5s9.26,2,10.17,1.94,1.51,0,1.89-1.13.9-3.27.9-3.27L43.14,42.23Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M42.85,33.85a4.8,4.8,0,0,0-.53,3.23c.22.74.88,1.12,2,1.42,2.91.82,13.05,2.33,14.64,2.78s2.72-1.84,3-2.73l.24-.88S43.21,33.48,42.85,33.85Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.77,51.85s2.58-.24,3.37,1.88,3.44,7.52,3.44,7.52",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M97.29,47c.62-.91,1.95,1.41,2,3a4.61,4.61,0,0,1-1.1,3.68c-.73.91-.86.82-1.09.86C96.21,54.67,96.66,47.91,97.29,47Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M111.16,59.86a4.15,4.15,0,0,1,1.77,3.24,5.51,5.51,0,0,1-1.25,4.7l-.52-7.94Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M90,106c-.4-.56-1-1.29-1.25-1.08a3.8,3.8,0,0,0-.89,1.66c0,.42.9.06,1.31-.1A4.07,4.07,0,0,0,90,106Zm10.41,6.49c.08.5,0,1-.47,1.17a40.37,40.37,0,0,1-6,.29c-2.46-.06-9.52-.17-10.27-.22-.9-.06-1.86-.12-2.07-.43-.36-.51.38-2.64.38-2.64s5.34.71,8.45.86,7.39.62,8.41.51a6.29,6.29,0,0,0,1.23-.18,1,1,0,0,1,.32.64Zm-9.25-6.18a1.25,1.25,0,0,1-.56.81Zm1.08.6a1.79,1.79,0,0,1-.44,1Zm1,.64a2.45,2.45,0,0,1-.37,1.13Zm1.07.74a2.38,2.38,0,0,1-.36,1.13Zm1,.85a1.18,1.18,0,0,1-.25.83Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M28.77,96.69c-1,0-6.42-.64-7.06,1.29s0,6.43,1.28,7.39S28.77,96.69,28.77,96.69Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M118,97.62c-2.26,3.24-6,10.1-9.39,13.63s-8.47,8.19-13.49,8.36c-3.67.12-12.17.1-17.68-.1-2-.08-11.2-.49-14.24-3.14s6.66-12.67-2.71-18.8c-9.18-6-14.1-7.26-14.1-7.26l6.16-3.08L81,90.15s-7.4,9.13-3.08,15.09c2.85,3.92,5.19,3.41,9.4,4.38s8.1,1.3,11.35-1.62,8.9-11,9.88-14.6",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M51.64,108.49l-9.07-1.63.16-.56,9.72,1.13Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M50.26,88.53s-.37-4.22.61-5.52a4.59,4.59,0,0,1,4.09-2c1.94,0,14.56.21,16.33,0,2.69-.36,8.62,1,9.76,1.49s2.1,5.35,1.78,6A7.28,7.28,0,0,1,81,90.16Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M50.26,88.53s-.37-4.22.61-5.52a4.59,4.59,0,0,1,4.09-2c1.94,0,14.56.21,16.33,0,2.69-.36,8.62,1,9.76,1.49s2.1,5.35,1.78,6A7.28,7.28,0,0,1,81,90.16Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M54.56,67.39c-1.37,1.84-3,5.37-2.53,7.45s1.9,5.71,3.73,5.85C78.51,82.4,85,79.38,85.89,80.53c.29.37-1,3,.13,7.82a67.59,67.59,0,0,1,2.27,17.86c0,.65,5.39,1.26,4.61-.08s.45-19.44.55-23.3c.19-7.32-1.26-9.57-4.23-10.5-2.15-.66-17-1.53-20.25-2s-14.41-3-14.41-3Zm17-36.31c-.84,1-.82,2.74-.86,3.53a8.22,8.22,0,0,0,1.41,4.59s0-.22-1.87-.66-5.48-1.61-5.48-1.61,1.1-2.74,1.49-3.77c1.46-3.8.23-7.4.29-7.75s2.93,1.35,2.93,1.35L70.71,31l.86.09Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M76.24,20A6.45,6.45,0,0,1,77,24.55a5.35,5.35,0,0,0,1,3.6c.15.45-1,.37-1,.37s-.35,1.69-.56,2.39-.48,1.61-1.56,1.61c-.81,0-3.91,0-4.84-2.11s-1.64-5.42-.53-7S75.54,19.23,76.24,20Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M69.05,25.16l7.4.48m1.09.29c-.13,1-.46,1.73-.75,1.7s-.42-.86-.29-1.84.46-1.73.75-1.69.42.86.29,1.83Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M71.21,37S73,40.49,74.27,43.7c1.4,3.6.84,6.53-1.09,7.68C70.43,55.65,67.46,66,67.46,66L53.9,67.28l-.31-3.55S54.79,49.89,58,43.26c2.42-5,6.83-8.3,7.51-8.36,1.7-.13,5.74,2.14,5.74,2.14",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M64.07,27c-3.5,2.07-2.84-9.94-14.25-6-5.16,1.77-10,1.93-12.46-1.15-3.74-4.65-4.5,8.39.8,12.77,4.58,3.79,8.7,1,13.81-1.54s6.73,1.25,10.33,2.19c5.85,1.53,10.27-3.6,7.9-10.1-.72-2,.13.14-6.13,3.84",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M85.29,71.56s-9.35-.5-15.14-1.38a10,10,0,0,1-2.24-.65L67.77,65l-13-.73-2.92,6c-1.14,6-.68,12.6,7.14,13.22,6.66.53,22.84-.73,23.53-.77.81-.55,2.24-5.53,2.7-7.53C85.47,71.64,85.29,71.56,85.29,71.56Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M73.93,56.63c2.39.49,7.95,2.21,9,2.5A121.61,121.61,0,0,0,95.8,61.68c.4-.06,1.23.44,1.32,2,0,.54.1,1.68-.65,1.55s-2.13-.06-2.63-.09c-1.11-.06-.83.1-4.43-.13a125.49,125.49,0,0,1-17.78-2,3.36,3.36,0,0,1-1.72-2c-.42-1,.33-.85.72-2.18C71.27,56.81,73.93,56.63,73.93,56.63Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M112,111.31c-.67,1-.92,6.61,1.08,10.12s5.84,7,12.68,6.93,10.27-3.43,12.52-8c2.75-5.61.83-11.7-2-15.37s-8.1-5.69-14.69-3.68c-7.72,2.34-9.59,10-9.59,10",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M119.34,111.73a6.41,6.41,0,0,0,.06,4.39,6.5,6.5,0,0,0,6.32,4.07,5.64,5.64,0,0,0,5.82-4.45c.57-2.57-.5-5.83-2.18-7.15a6.69,6.69,0,0,0-7-.5A6.6,6.6,0,0,0,119.34,111.73Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M28.43,110.88c-.66,1-.92,6.6,1.08,10.11s5.85,7,12.69,6.93,10.26-3.42,12.51-8c2.75-5.6.84-11.7-2-15.37S44.62,98.84,38,100.85c-7.72,2.35-9.6,10-9.6,10",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M36,110.89a6.41,6.41,0,0,0,.06,4.39,6.52,6.52,0,0,0,6.32,4.08c3.2-.07,5.26-1.88,5.83-4.45s-.5-5.84-2.19-7.15a6.65,6.65,0,0,0-6.95-.5A6.56,6.56,0,0,0,36,110.89Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M104,69.26s-1.88.21-1.46,2.93,3.64,12.13,3.34,20.16c-.32,8.25-2.71,10.55-5.84,14.3s-4.38,4.6-4.38,4.6a12.14,12.14,0,0,0,8.13-1.67c4-2.51,23.57-11.8,23.57-11.8s2.71-8.57-8.66-15.46c-8.63-5.24-12.41-12.64-12.61-13.68C104.8,69.06,104,69.26,104,69.26Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M100.52,65.4a2.82,2.82,0,0,1,1.82.57A6.36,6.36,0,0,1,104,69.63a3.15,3.15,0,0,0,2.09-1s-.16,0,.88,0,4.15-.18,4.64-.73.63-5.75-.83-8.67c-1.2-.42-3.44-.37-5.79,1.46s-2.87,2.56-3.49,2.77a12.25,12.25,0,0,1-1.62.36Zm9,55.29s-3.76-10.42.89-17.46a17,17,0,0,1,18.67-6.83c6.26,2,10.84,7.72,10.4,9.29s-2.69,2.24-5.37,2.24-6.84-2-11.15.39c-3.65,2-2.49,4.54-4.05,7.67S114.49,121.81,109.57,120.69Zm-88.8-12.85c-.9-1.14,7.38-14.45,18.72-16.8,5.75-1.18,10.95-1.51,15.55.25,8.77,3.35,12.94,13.38,12.52,19.85-.12,1.89-.33,3.78-.62,5.65,0,0-16.9.41-33.16-4C29.84,111.76,21.68,109,20.77,107.84Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M43.48,107.39a82.6,82.6,0,0,0,9.07.94m-10,3a79.9,79.9,0,0,0,9.07.94Zm.47-1.88a79.9,79.9,0,0,0,9.07.94Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M67,30.3c1.64-.64-.68-1.59-1.38-2.62-.31-.45-1.07-1.52-.11-2.16a4.49,4.49,0,0,0,2-1.83c.8-1.24.9-4.83,2.81-5.81,3.52-1.8,7.57-.23,7.46,2.08-.05,1,.09,3.46-3.89,4.28-1.52.31-2.94-1.1-2.62,3a5.23,5.23,0,0,1-3.58,5.16",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M78.51,20.49a7.17,7.17,0,0,0-3.62-5.34c-2.77-1.42-5.21-2.32-9.39-.51a8.06,8.06,0,0,0-4.89,8.49,28.62,28.62,0,0,0,2.11,6s2.89.68,3.92.77a3,3,0,0,0,2.91-1c.92-1.08.85-1.74.75-3.46a3.42,3.42,0,0,1,1.15-3.23,4.69,4.69,0,0,1,3.13-1C76.24,21.1,78.51,21.2,78.51,20.49Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M110.46,103.23a13.23,13.23,0,0,0-1.63,3.59c7.17-3.67,18.49-9,18.49-9a7.8,7.8,0,0,0,.27-1.77A17.12,17.12,0,0,0,110.46,103.23ZM66.94,116.79s.43-2.57.62-5.65C68,104.67,63.81,94.65,55,91.29a20.61,20.61,0,0,0-8.2-1.21l-.47.23s4.92,1.25,14.1,7.26c9.37,6.13-.32,16.15,2.72,18.8a4.77,4.77,0,0,0,.54.41C65.76,116.82,66.94,116.79,66.94,116.79ZM77.81,105s.9,8.65,9.62,8.15,10.09-4.23,10.09-4.23A39.94,39.94,0,0,1,84,109C80.31,108.33,79.37,106.87,77.81,105Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M102.16,111c.07.42,0,.79-.39,1a33.49,33.49,0,0,1-4.94.24c-2,0-7.87-.14-8.49-.19s-1.54-.09-1.71-.34c-.3-.42.31-2.16.31-2.16s4.42.58,7,.7,6.11.51,7,.42a5.93,5.93,0,0,0,1-.14.74.74,0,0,1,.26.51",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M101.9,110.47a1.06,1.06,0,0,0-.59-.8,26.85,26.85,0,0,1-5.19-2.48c-1.12-.7-2.34-1.49-2.67-1.7s-1.57.79-1.71.92a3.11,3.11,0,0,1-1.43.32,1.11,1.11,0,0,1-.94-.33c-.23-.24,0-1.17-.51-1.18a1.26,1.26,0,0,0-1,.29,11.55,11.55,0,0,0-.62,2.15c-.08.58-.31,1.78-.31,1.84a17.16,17.16,0,0,0,4.62.69c2.78.18,7.7.49,8.58.49a6.06,6.06,0,0,0,1.76-.2",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.07,46.76s9.06-5.22,13.41-4c-.26-1.37-2.63-2.78-4.72-2.9A7.83,7.83,0,0,0,57,43.62C56.57,44.22,55.07,46.76,55.07,46.76ZM70.5,55s-11.27,6.81-11.76,7.35c-.79.84,0,3,.59,3.09s10.54-6.1,10.54-6.1l-.15-2.48L70.5,55Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M60.27,62.53l-7,1.62.22,2.06,7-2.36Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M61.08,44.11c.32,1.49,7,13.88,8.36,16.68,0,0,1.6,3.54,4.67,2s.34-6.91.34-6.91a41,41,0,0,0-2.92-6.48l-4.32-7.13S62.71,41.82,61.08,44.11Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M68.77,41.9c1.19,1.83,3.78,5.78,4.56,6.84-.51,1.55-3.1,3.8-7.93,6.22-3.6-4.25-4.41-7.91-4.5-10.1a5,5,0,0,1,2-4.33,3.74,3.74,0,0,1,3.34-.59A4.69,4.69,0,0,1,68.77,41.9Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M100.64,64.25a1.9,1.9,0,0,1-.58,1.43,1.47,1.47,0,0,1-.57.35,1.43,1.43,0,0,1-.65.06c-.69-.11-1,.12-1.56-.87a1.63,1.63,0,0,1-.17-1.2,2.47,2.47,0,0,1,.81-1.23,1.61,1.61,0,0,1,.65-.33,1.64,1.64,0,0,1,.73,0,1.61,1.61,0,0,1,.66.31,1.7,1.7,0,0,1,.46.57,1.92,1.92,0,0,1,.22.92",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M95.4,61.72a10.18,10.18,0,0,1,3.67-.92c1.31.13,5.18,2.34,5,3.15-.15.64-1.83-.13-2.09-.39s-.17,1.29-.57,1.68-1.19.63-1.23.41c-.12-.51.06-2.16-.46-2.55a1.31,1.31,0,0,0-2.07.42,1.49,1.49,0,0,0-.17.53,1.33,1.33,0,0,0,.07.56,1.2,1.2,0,0,0,.29.47,1.25,1.25,0,0,0,.47.31c.39.13,1.66,0,1.83.46s.13.47-.14.56-1.1,0-1.59.07a2.5,2.5,0,0,1-1.45-.07A18.12,18.12,0,0,1,95,65Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.2,23.18c-.72-2,.12.14-6.13,3.84-1.27.75-2-.35-2.94-1.86a36.31,36.31,0,0,0,1.59,3.95s2.88.68,3.92.77a3,3,0,0,0,2.91-1c.92-1.08.85-1.74.75-3.46a5.27,5.27,0,0,1,.11-1.62c-.06-.23-.13-.44-.21-.66",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M72.09,39.17l0,0S72.12,39.19,72.09,39.17Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M49.37,50.42a3.85,3.85,0,0,1,.68.1,3.22,3.22,0,0,1,1.77,1.18,3.51,3.51,0,0,1,.44.75,3.28,3.28,0,0,1-.28,3,7.2,7.2,0,0,1-.85,1c-.9,1-1.82,1.94-2.73,2.91-.06,0-.11.13-.19.15a.16.16,0,0,1-.18-.08c-.15-.34-.28-.69-.42-1-.46-1.17-1-2.34-1.41-3.51A3.39,3.39,0,0,1,46,53.5a3.29,3.29,0,0,1,.61-1.73A3.45,3.45,0,0,1,48,50.68,3.25,3.25,0,0,1,49.37,50.42Zm0,.8a2.52,2.52,0,0,0-2.44,1.68,2.64,2.64,0,0,0-.06,1.37,2.36,2.36,0,0,0,.82,1.34,2.58,2.58,0,0,0,2.48.41A2.34,2.34,0,0,0,51.37,55a2.57,2.57,0,0,0,.35-1.24,2.51,2.51,0,0,0-.6-1.62,2.4,2.4,0,0,0-1.21-.79A5.4,5.4,0,0,0,49.33,51.22Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M49.35,51.68a2,2,0,0,1,1.84,1.48,2.08,2.08,0,0,1-.12,1.39,2,2,0,0,1-1,1,2.1,2.1,0,0,1-1.48.06,2.05,2.05,0,0,1-1.34-1.67,2,2,0,0,1,.42-1.49A2,2,0,0,1,49.35,51.68Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M44.18,51.66a.32.32,0,1,1-.24.45A.32.32,0,0,1,44.18,51.66Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M44.94,52.25a.3.3,0,0,1,.3-.38l.92.18c-.09.18-.15.37-.23.55l-.74-.14A.3.3,0,0,1,44.94,52.25Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M43.49,53.08a.27.27,0,0,1,.25-.09l2,.38a5.86,5.86,0,0,0,0,.59l-2.16-.41A.29.29,0,0,1,43.49,53.08Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M41.62,54a.33.33,0,0,1,.39.31.32.32,0,0,1-.46.3.32.32,0,0,1-.16-.41A.33.33,0,0,1,41.62,54Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M42.57,54.22a.42.42,0,0,1,.27,0l3.12.59c.07.22.18.42.25.64l-3.56-.67a.29.29,0,0,1-.08-.56Z",
    transform: "translate(-2.64 -9.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M43.48,55.93a.3.3,0,0,1,.31-.13l2.77.53c.09.21.18.42.26.63h-.13l-3-.57a.3.3,0,0,1-.23-.23A.42.42,0,0,1,43.48,55.93Z",
    transform: "translate(-2.64 -9.17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryMan);
export default __webpack_public_path__ + "static/media/delivery_man.a5a109fb873116ad79c7eae2bd60e46b.svg";
export { ForwardRef as ReactComponent };